'use strict';

angular.module('chatEngine.login', [
    'chatEngine.services',
    'chatEngine.dialog',
    'chatEngine.mixpanel'
])

.controller('LoginCtrl', ['$scope', '$window', '$http', '$location','$timeout', '$modal', 'Dialog', 'socketService',
    'authService', 'mixpanelService', 'kikService', 'DEBUG', 'BOTSWORTH_USERNAME', 'storageService',
    'alertService',
    function($scope, $window, $http, $location, $timeout, $modal, Dialog, socketService, authService,
    mixpanelService, kikService, DEBUG, BOTSWORTH_USERNAME, storageService, alertService) {

    mixpanelService.forceTrack('Login Show');

    $scope.message = 'default';

    function init() {
        authService.clearAuthCookies();
        $scope.showScanLoader = true;
        $scope.waiting = false;
        $scope.slideMessageUp = false;
        if (DEBUG && $location.search().username) {
            devLogin();
        } else if (kikService.utils && ['ios', 'android'].indexOf(kikService.utils.platform.os.name) !== -1) {
            if (kikService.enabled) {
                // Inside kik
                $scope.kikLogin();
            } else {
                // Not in kik, try to open in Kik
                $timeout(function() {
                    window.location.protocol = 'cards';
                }, 1000);
                scanLogin();
            }
        } else {
            scanLogin();
        }
    }

    $scope.kikLogin = function() {
        $scope.hideInstructions = true;
        $scope.message = 'kikLogin';

        $scope.showScanLoader = true;
        var DATA_TO_SIGN = {data: 'login'};
        kikService.sign(JSON.stringify(DATA_TO_SIGN), function(signedData, username, host) {
            if (!signedData) {
                $scope.$apply(function() {
                    $scope.showScanLoader = false;
                    $scope.message = 'kikLoginTerminated';
                    scanLogin();
                });
            } else {
                $scope.showScanLoader = true;
                $http.post(
                    '/api/v1/kik-session',
                    {
                        'signedData': signedData,
                        'username': username,
                        'host': host
                    }
                ).success(function(data) {
                    if (data && data.cookie) {
                        socketService.closeSocket();
                        $scope.success = true;

                        animateLogin(data, function() {
                            authService.setEngineCookie(data.cookie);

                            $http.get('/api/v1/contact')
                                .error(function() {
                                    Dialog.alert('Error', 'An error occurred while loading your information.');
                                })
                                .success(function(response) {
                                    alertService.setShowAppleIdAlert(!response.apple_developer_id);
                                });
                        });

                        mixpanelService.forceTrack('Kik Login Success');
                    } else {
                        $scope.message = 'error';

                        mixpanelService.forceTrack('Kik Login Token Error');
                    }
                })
                .error(function(data, status) {
                    $scope.showScanLoader = false;
                    scanLogin();
                    if (status === 404) {
                        $scope.message = 'createBotMessage';
                        mixpanelService.forceTrack('Kik Login No Bots');
                    } else {
                        $scope.message = 'error';
                        mixpanelService.forceTrack('Kik Login Failed');
                    }
                });
            }
        }, true);
    };

    function scanLogin() {
        $scope.hideInstructions = false;
        $http.get('/api/v1/login')
        .success(function(data) {
            $scope.kikCode = data.code;
            socketService.init(data.socketId, data.socketToken);
        })
        .error(function() {
            $scope.codeError = true;
            $scope.kikCode = '/assets/img/kikcodefail.png';
            $scope.message = 'errorKikCode';

            mixpanelService.forceTrack('Login Kik Code Error');
        });
    }

    function devLogin() {
        var username = $location.search().username;
        $http.get('/api/v1/debug/session', {params: {username: username}})
        .success(function(data) {
            $location.search('username', null);
            socketService.closeSocket();
            animateLogin(data, function() {
                authService.setEngineCookie(data.cookie);
            });
        });
    }

    function animateLogin(data, callback) {
        $scope.message = 'success';
        $timeout(function() {
            if (data.new_bot) {
                storageService.setItem('last-route', '/engine');
            }
            if (!data.tos) {
                $location.path('/tos');
            } else {
                var path = storageService.getItem('last-route');
                if(!path || path === '/home') {
                    path = '/reporting';
                }
                $location.path(path);
                storageService.removeItem('last-route');
            }
            callback();
        }, 700);
    }

    init();

    $scope.createBot = function() {
        $scope.createBotMessage = false;
        $scope.showScanLoader = true;
        $scope.message = 'kikLogin';
        var DATA_TO_SIGN = {data: 'create'};
        kikService.sign(JSON.stringify(DATA_TO_SIGN), function(signedData, username, host) {
            if (!signedData) {
                $scope.$apply(function() {
                    $scope.showScanLoader = false;
                    $scope.createBotMessage = true;
                    $scope.message = 'createBotTerminated';
                });
            } else {
                $scope.showScanLoader = true;
                $http.post(
                    '/api/v1/botsworth/bot/kik_create',
                    {
                        'signedData': signedData,
                        'username': username,
                        'host': host
                    }
                ).success(function() {
                    kikService.openConversation(BOTSWORTH_USERNAME);
                    mixpanelService.forceTrack('Kik Login Botsworth Create');
                })
                .error(function(data, status) {
                    $scope.showScanLoader = false;
                    if (status === 409) {
                        $scope.message = 'creatingBotMessage';
                        mixpanelService.forceTrack('Kik Login Botsworth Conflict');
                    } else {
                        $scope.message = 'error';
                        mixpanelService.forceTrack('Kik Login Botsworth Create Failed');
                    }
                });
            }
        }, true);
    };

    $scope.openConvo = function() {
        kikService.openConversation(BOTSWORTH_USERNAME);
    };

    $scope.$watch('showScanLoader', function(current) {
        if (!current) {
            $scope.waiting = false;
            var ignoreMessageList = [
                'loginTerminated',
                'kikLoginTerminated',
                'noBots2',
                'error',
                'createBotMessage',
                'creatingBotMessage'
            ];

            if(ignoreMessageList.indexOf($scope.message) === -1) {
                $scope.message = 'default';
            }
        }
    });

    $scope.$on('LoginSuccess', function(event, data) {
        if (data && data.cookie) {
            $scope.$apply(function() {
                socketService.closeSocket();
                animateLogin(data, function() {
                    authService.setEngineCookie(data.cookie);
                });
            });

            mixpanelService.forceTrack('Login Success');
        } else {
            $scope.$apply(function() {
                $scope.message = 'errorToken';
                $timeout(init, 800);
            });

            mixpanelService.forceTrack('Login Token Error');
        }
    });

    $scope.$on('NoBots', function() {
        $scope.$apply(function() {
            $scope.message = 'noBots';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login No Bots');
    });

    $scope.$on('ExpiredKey', function() {
        $scope.$apply(function() {
            $scope.message = 'expiredKey';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login Expired Key');
    });

    $scope.$on('WaitingForConfirmation', function() {
        $scope.$apply(function() {
            $scope.waiting = true;
            $timeout(function() {
                $scope.slideMessageUp = true;
                $scope.message = 'waitingConfirmation';
            }, 200);
        });

        mixpanelService.forceTrack('Login Waiting Confirmation');
    });

    $scope.$on('EmailRequired', function() {
        $scope.$apply(function() {
            $scope.waiting = true;
            $timeout(function() {
                $scope.slideMessageUp = true;
                $scope.message = 'emailRequired';
            }, 200);
        });

        mixpanelService.forceTrack('Login Email Verification Required');
    });

    $scope.$on('LoginTerminated', function() {
        $scope.$apply(function() {
            $scope.slideMessageUp = false;
            $scope.message = 'loginTerminated';
            $timeout(init, 200);
        });

        mixpanelService.forceTrack('Login Terminated');
    });

    $scope.$on('socketError', function() {
        $scope.$apply(function() {
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Login Socket Error');
    });

    $scope.$on('$destroy', function() {
        socketService.closeSocket();
    });

    var authUser = $location.search().authuser;

    if (parseInt(authUser) === 1) {
        $timeout(function() {
            Dialog.alert('Access Denied', 'Please log in with an authorized account and then try again');
            authService.clearAuthCookies();
        }, 300);
    }

    $scope.scanCodeTutorial = function() {
        $modal.open({
            templateUrl: 'views/scan-code-tutorial-dialog.html',
            windowClass: 'scan-code-tutorial-dialog'
        });
    };
}]);
